module.exports = __webpack_public_path__ + "static/img/dict_desk_bg.83f5129.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dict_desk_bg.png
// module id = OxEo
// module chunks = 1